(function () {
  function safeParseJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse((el.textContent || "").trim());
    } catch (e) {
      return null;
    }
  }

  function cssEscape(v) {
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(String(v));
    return String(v).replace(/[^a-zA-Z0-9_\u00A0-\uFFFF-]/g, "\\$&");
  }

  function getData(vs) {
    const variants = safeParseJSON(vs.querySelector('script[type="application/json"][data-hc-variants]'));
    const options = safeParseJSON(vs.querySelector('script[type="application/json"][data-hc-options]'));
    if (!Array.isArray(variants) || !Array.isArray(options)) return null;
    return { variants, options };
  }

  function getSelected(vs, optionCount) {
    const out = new Array(optionCount).fill("");
    for (let i = 0; i < optionCount; i++) {
      const fs = vs.querySelector('fieldset[data-hc-option-index="' + i + '"]');
      if (!fs) continue;
      const checked = fs.querySelector('input[type="radio"]:checked');
      out[i] = checked ? checked.value : "";
    }
    return out;
  }

  function matchesPrefix(variant, selected, optionIndex) {
    for (let i = 0; i < optionIndex; i++) {
      const sel = selected[i];
      if (!sel) return false;
      if (variant.options[i] !== sel) return false;
    }
    return true;
  }

  function statusForValue(variants, selected, optionIndex, value) {
    let possible = false;
    let available = false;
    for (let i = 0; i < variants.length; i++) {
      const v = variants[i];
      if (!v || !Array.isArray(v.options)) continue;
      if (v.options[optionIndex] !== value) continue;
      if (!matchesPrefix(v, selected, optionIndex)) continue;
      possible = true;
      if (v.available) {
        available = true;
        break;
      }
    }
    return { possible, available };
  }

  function setState(vs, input, st) {
    const id = input.getAttribute("id");
    const label = id ? vs.querySelector('label[for="' + cssEscape(id) + '"]') : null;
    if (!label) {
      if (!st.possible) input.disabled = true;
      else input.disabled = !st.available;
      if (st.available) input.classList.remove("disabled");
      else input.classList.add("disabled");
      return;
    }

    if (!st.possible) {
      label.classList.remove("hc-soldout", "hc-available");
      label.classList.add("hc-nonexistent");
      label.style.display = "none";
      input.disabled = true;
      input.classList.add("disabled");
      return;
    }

    label.classList.remove("hc-nonexistent");
    label.style.removeProperty("display");

    if (st.available) {
      label.classList.remove("hc-soldout");
      label.classList.add("hc-available");
      input.disabled = false;
      input.classList.remove("disabled");
      return;
    }

    label.classList.remove("hc-available");
    label.classList.add("hc-soldout");
    input.disabled = true;
    input.classList.add("disabled");
  }

  function applyGroup(vs, data, optionIndex) {
    const fs = vs.querySelector('fieldset[data-hc-option-index="' + optionIndex + '"]');
    if (!fs) return false;

    const inputs = fs.querySelectorAll('input[type="radio"]');
    if (!inputs || !inputs.length) return false;

    const selected = getSelected(vs, data.options.length);

    const meta = [];
    inputs.forEach(function (input) {
      const st = statusForValue(data.variants, selected, optionIndex, input.value);
      setState(vs, input, st);
      meta.push({ input: input, possible: st.possible, available: st.available });
    });

    const checked = fs.querySelector('input[type="radio"]:checked');
    if (!checked) return false;

    let checkedMeta = null;
    for (let i = 0; i < meta.length; i++) {
      if (meta[i].input === checked) {
        checkedMeta = meta[i];
        break;
      }
    }

    const invalid =
      !checkedMeta ||
      !checkedMeta.possible ||
      checked.disabled ||
      (checkedMeta.possible && !checkedMeta.available);

    if (!invalid) return false;

    let next = null;
    for (let i = 0; i < meta.length; i++) {
      const m = meta[i];
      if (m.possible && m.available && !m.input.disabled) {
        next = m.input;
        break;
      }
    }
    if (!next) {
      for (let i = 0; i < meta.length; i++) {
        const m = meta[i];
        if (m.possible) {
          next = m.input;
          break;
        }
      }
    }

    if (next && next !== checked) {
      vs.dataset.hcSoldoutSynthetic = "1";
      next.checked = true;
      next.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }

    return false;
  }

  function apply(vs) {
    const data = getData(vs);
    if (!data) return;

    for (let i = 0; i < data.options.length; i++) {
      const changed = applyGroup(vs, data, i);
      if (changed) return;
    }
  }

  function settle(vs) {
    if (!vs) return;
    if (vs.dataset.hcSoldoutQueued === "1") return;
    vs.dataset.hcSoldoutQueued = "1";
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        vs.dataset.hcSoldoutQueued = "0";
        apply(vs);
      });
    });
  }

  function init(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll("variant-selects").forEach(function (vs) {
      settle(vs);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    init(document);
  });

  document.addEventListener("page:loaded", function () {
    init(document);
  });

  document.addEventListener("shopify:section:load", function (e) {
    init(e && e.target ? e.target : document);
  });

  document.addEventListener("change", function (e) {
    const vs = e.target && e.target.closest ? e.target.closest("variant-selects") : null;
    if (!vs) return;

    if (vs.dataset.hcSoldoutSynthetic === "1") {
      vs.dataset.hcSoldoutSynthetic = "0";
      settle(vs);
      return;
    }

    settle(vs);
  });

  if (typeof window.subscribe === "function" && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
      init(document);
    });
  }
})();
